import { Select, SelectOptionType } from '@bp/ui-components';
import classNames from 'classnames';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { SingleValue } from 'react-select';
import { usePriorityOptions } from '../../../../hooks/usePriorityOptions';
import styles from '../../Constraints.module.scss';

/**
 * Compact, colour-coded priority dropdown (icon-only) bound to a Formik field. Shared by every
 * conditions form row that carries a priority (number caps + the subject edge-of-day toggle).
 */
export const PriorityIconSelect = ({ name }: { name: string }) => {
  const { t } = useTranslation();
  const { values, setFieldValue, setFieldTouched } = useFormikContext<Record<string, unknown>>();
  const priorityOptions = usePriorityOptions();
  const value = values[name];

  return (
    <Select
      className={classNames(
        styles['priority-icon-select'],
        styles[`icon-${String(value ?? 'OPTIMIZING').toLowerCase()}`],
      )}
      options={priorityOptions}
      value={priorityOptions.find((o) => o.value === value) ?? null}
      onChange={(option) => {
        const opt = option as SingleValue<SelectOptionType>;
        setFieldTouched(name, true);
        setFieldValue(name, opt?.value ?? 'OPTIMIZING');
      }}
      label={t('common.priority.full')}
      name={name}
      fitMenuToOptions
      showIconOnly
    />
  );
};
